import PetEgg from './PetEgg'

export default PetEgg
